import {
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import * as Auth from "../../authService";

// Pages that are reachable without a Proview session. The SSO callback must not be redirected to /login:
// the Header is wrapped by this HOC and rendered on every route, and that redirect would rewrite the URL
// (dropping ?code=&state=) before SsoCallback reads it, so the sign-in could never complete.
const PUBLIC_PATHS = ["/login", "/sso/callback"];

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    let isAuthenticated = Auth.loggedIn();
    if (isAuthenticated) {
      return <Component {...props} {...{ location, navigate, params }} />;
    }
    if (PUBLIC_PATHS.includes(location.pathname)) {
      return null;
    }
    return <Navigate to={"/login"} replace={true} />;
  }
  return ComponentWithRouterProp;
}
export default withRouter;
